import { DatePipe } from "@angular/common";
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from "@angular/core";
import { NgbModal, NgbPopover } from "@ng-bootstrap/ng-bootstrap";
import { CsAgentAuthService } from "@spartacus/asm/root";
import { BaseSiteService, GlobalMessageService, GlobalMessageType, OccEndpointsService, RoutingService, TranslationService } from "@spartacus/core";
import { UserAccountFacade } from "@spartacus/user/account/root";
import { Observable, Subscription } from "rxjs";
import { filter, map, take } from "rxjs/operators";
import { CustomProfileAndPreferencesService } from 'src/app/custom-profile-and-preferences/custom-profile-and-preferences.service';
import { DataLayerService } from '../../services/data-layer.service';
import { MultiFactorAuthService } from '../../services/multi-factor-auth.service';
import { SharedService } from '../../services/shared.service';
import { AddCardComponent } from '../add-card/add-card.component';
import { AddCardService } from '../add-card/add-card.service';
import { CheckoutService } from '../checkout/checkout.service';
import { OtpModalComponent } from '../otp-modal/otp-modal/otp-modal.component';
import {
  enumPaymentMethods,
  paymentPreferenceMapping,
} from './payment-method.constants';
import { PaymentMethodService } from './payment-method.service';
import * as _ from 'lodash';

@Component({
  selector: 'app-payment-method',
  templateUrl: './payment-method.component.html',
  styleUrls: ['./payment-method.component.scss']
})
export class PaymentMethodComponent implements OnInit, OnChanges, OnDestroy {

  @Input() stdCartType: boolean = true;
  @Input() orderFlu: boolean = false;   //used for confirmation pages
  @Input() editFluReservation: boolean = false;
  @Input() cancelFluReservation: boolean = false;
  @Input() paymentMethod: any;  //used for confirmation pages
  @Input() cardDetails: any;  //used for confirmation pages
  @Input() stdCheckoutFlow = false; // for normal checkout flow

  @ViewChild('cardp1', { static: false }) public expiryPopover: NgbPopover;
  @ViewChild('defaultCard', { static: false }) public expiryPopoverDefault: NgbPopover;

  @Output() selectedPaymentMethodEvent = new EventEmitter<any>();
  @Output() selectedCardOAcctDetailsEvent = new EventEmitter<any>();

  billmelaterEnum: string = enumPaymentMethods.BILL_ME_LATER;
  paybycardEnum: string = enumPaymentMethods.PAY_BY_CARD;
  paybycard3dpriorEnum: string = enumPaymentMethods.PAY_BY_CREDIT_CARD_3DPRIOR;
  paybycheckEnum: string = enumPaymentMethods.PAY_BY_CHK_ACCOUNT;
  paybycheck3dpriorEnum: string = enumPaymentMethods.PAY_BY_CHK_ACCOUNT_3DPRIOR;

  //payment method dropdown related
  paymentMethodsArray: any = [];
  displayPaymentMethod: string;
  chosenPaymentMethod: string;
  hidePaymentMethod: boolean = false;
  selectedPaymentMethod: any;

  paymentPrefenceArray: any = [];

  paymentTerms: string = '';
  paymentPreference: string = '';

  //Card related details
  userCardDataArray: any = [];
  chosenCard: any;
  selectedcardHolderName: string;
  selectedcardNumber: string;
  selectedcardType: string;
  selectedcardRoutingNumber: string;
  selectedexpDate: string;
  selectedExpWithinSixMonths = false;
  cardExpiredFlag = false;
  creditCardDefault = false;
  userTemporaryCard: any;
  userCardData: any = [];

  //Account related details:
  userAccountDataArray: any = [];
  chosenAccount: any;
  selectedAccountHolderName: string;
  selectedAccountNumber: string;
  selectedAccountType: string;
  selectedAccountRoutingNumber: string;
  selectedAccountBankName: string;
  selectedAccountexpDate: string;
  accExpiredFlag = false;
  accDefault = false;

  newCardOrAccountDetails;
  newCardOrAccountDetailsArr = [];

  orderOrReservation: string = '';
  popoverCloseTimeOut: any;

  baseUrl: any;
  langSelected: string;
  userId: any;
  userFname: any;
  userLname: any;
  userEmail: any;
  usergetDataObj: any;
  getuserData: any;

  isAsmUser: boolean = false;
  csAgentAuthSubscription: Subscription;
  //Subscriptions
  userDataSub: Subscription;
  userAccountSubscriber: Subscription;
  userAccountDetailsSubscriber: Subscription;
  cardDetailsPfSubscriber: Subscription
  addCardSubscriber: Subscription;
  editCancelPaymentData: any;
  editPaymentType: string = '';
  baseSiteId: string;
  editCancelFluSub: Subscription;
  currentPopover: NgbPopover;
  mfaSubscription: Subscription;

  constructor(private readonly modalService: NgbModal,
    private readonly paymentMethodService: PaymentMethodService,
    private readonly translation: TranslationService,
    private readonly globalMessage: GlobalMessageService,
    private readonly user: UserAccountFacade,
    private readonly ref: ChangeDetectorRef,
    private readonly router: RoutingService,
    private readonly occEndPoint: OccEndpointsService,
    private readonly pfService: CustomProfileAndPreferencesService,
    private readonly sharedService: SharedService,
    private readonly checkoutService: CheckoutService,
    private readonly addCardService: AddCardService,
    private baseSiteService: BaseSiteService,
    private mfaService: MultiFactorAuthService,
    private readonly csAgentAuthService: CsAgentAuthService,
    public datepipe: DatePipe,
    private readonly _datalayer: DataLayerService) {
    this.baseUrl = this.occEndPoint.getBaseUrl({
      baseUrl: true,
      prefix: false,
      baseSite: false,
    });
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.stdCartType) {
      this.orderOrReservation = "order";
    }
    else {
      this.orderOrReservation = "reservation";
    }
  }

  ngOnInit(): void {
    this.csAgentAuthSubscription = this.csAgentAuthService.isCustomerEmulated().subscribe((res) => {
      this.isAsmUser = res ? res : false;
    });
    let tempData = this.sharedService.getSessionStorage('tempoData');
    if (tempData) {
      this.newCardOrAccountDetailsArr = tempData;
    }
    this.baseSiteService.getActive().pipe(take(1)).subscribe(res => this.baseSiteId = res);
    if (this.cancelFluReservation) {
      //disable both selects
      //set payment method details
      if (!this.orderFlu) { //not to execute for order confirmation(orderFlu=true)
        this.getPaymentMethods().pipe(take(1)).subscribe((res) => {
          if (res != null && res !== undefined && res?.length > 0) {
            this.paymentMethodsArray = res;

            //set payment method details
            this.editCancelFluSub = this.paymentMethodService.editCancelFluPaymentMethodDtls.subscribe((data) => {
              if (data) {
                this.editCancelPaymentData = data;
                this.setPaymentDetails(this.editCancelPaymentData);
              }
            });
          }
        });
      }
    }
    else if (this.editFluReservation) {
      //if card or account, disable both selects and set payment payment method
      //else if bill me later, set default payment method as bill me later and execute normal flow.
      this.getPaymentMethods().pipe(take(1)).subscribe((res) => {
        if (res != null && res !== undefined && res?.length > 0) {
          this.paymentMethodsArray = res;
          //set payment method details
          this.editCancelFluSub = this.paymentMethodService.editCancelFluPaymentMethodDtls.subscribe((data) => {
            if (data) {
              this.editCancelPaymentData = data;
              this.editPaymentType = this.editCancelPaymentData?.paymentType;
              if (this.editPaymentType === 'CARD' || this.editPaymentType === 'ACCOUNT') {
                this.setPaymentDetails(this.editCancelPaymentData);
              }
              else { //bill me later prefill case , not based on payment term and preference
                this.paymentPreference = 'BM';
                this.setDefaultPaymentPreference();
                this.fetchUserAndCardDetails();
              }
            }
          });
        }
      });
    }
    else {
      //Normal scenario
      this.paymentTerms = this.sharedService.getLocalStorage('paymentTerms');
      this.paymentPreference = this.sharedService.getLocalStorage('paymentPreference');

      this.getPaymentMethods().pipe(take(1)).subscribe((res) => {
        if (res != null && res !== undefined && res?.length > 0) {
          this.paymentMethodsArray = res;
          if (this.paymentTerms !== undefined && this.paymentTerms !== null && this.paymentTerms == 'PRE') {
            this.paymentMethodsArray = res.filter((item) => item.code === enumPaymentMethods.PAY_BY_CARD || item.code === enumPaymentMethods.PAY_BY_CHK_ACCOUNT);
          }
          else if (this.paymentTerms !== undefined && this.paymentTerms !== null && this.paymentTerms?.startsWith('I')) {
            this.paymentMethodsArray = res.filter((item) => item.code === enumPaymentMethods.PAY_BY_CARD || item.code === enumPaymentMethods.PAY_BY_CHK_ACCOUNT || item.code === enumPaymentMethods.BILL_ME_LATER);
          }
          // else {
          //   console.log('payment term other than PRE and I*. Showing all options')
          // }
          this.setDefaultPaymentPreference();
        }
      });
      this.fetchUserAndCardDetails();
    }
    this.ref.detectChanges();
  }


  getCardDetailsAndUpdateExpDate(paymentData){
    this.userDataSub = this.user.get().subscribe((res: any) => {
      if (res) {
        this.userId = res?.uid;
        this.pfService.getCardFromDb(this.userId, this.getB2BUid());
        this.userDataSub?.unsubscribe();
        this.cardDetailsPfSubscriber = this.pfService.cardDetails.subscribe((data) => {
          if (data) {
            let userCardDataArray = [];
            let userCardData = data?.sanofiPaymentsResponseList; // user saved cards and checking account details

            if (userCardData?.length > 0) {
              userCardData.forEach((element, index) => {
                if (element?.cardType != 'EC') {
                  const card = `${element?.cardType} Card(XXXX-XXXX-XXXX-${element?.cardNumber.substring(6, 10)})`;
                  const objCard = {
                    name: card,
                    code: userCardData?.length + 1,
                    cardHolderName: element?.creditCardName,
                    cardNumber: element?.cardNumber,
                    cardType: element?.cardType,
                    expDate: element?.expDate,
                    creditCardDefault: element?.creditCardDefault,
                    cardExpired: element?.cardExpired,
                    routingNumber: element?.routingNumber ? element?.routingNumber : '',
                    newCardDefault: element?.newCardDefault ? element?.newCardDefault : false
                  };
                  userCardDataArray.push(objCard);
                }
              });
            }
            let editCard = userCardDataArray.find(
              (item) => item?.cardNumber == paymentData?.cardNumber && item?.cardType ==paymentData?.cardType
            );
            if(editCard){
              //console.log('profile card exp date',editCard?.expDate);
              this.selectedexpDate = editCard?.expDate;
              let stillGoingToExpire = this.isExpDateWithinSixMonths(this.selectedexpDate);
              if(stillGoingToExpire){
                this.closePopover(this.expiryPopoverDefault); //if opened for default card, closing it
                this.openPopover(this.expiryPopover);
              }
            }
            else{ // if card in order not found in profile, considering order exp date and showing popup
              this.closePopover(this.expiryPopoverDefault); //if opened for default card, closing it
              this.openPopover(this.expiryPopover);
            }
            this.emitCardOrAccountDetails('CARD');
            this.ref.detectChanges();
            this.cardDetailsPfSubscriber?.unsubscribe();
          }
        });
      }
    });
  }

  getB2BUid() {
    let b2bUid: string;
    if ('selectedLocations' in sessionStorage) {
        b2bUid = JSON.parse(sessionStorage.getItem('selectedLocations'))[0].accountNumber;
    } else {
        //default location
        b2bUid = JSON.parse(sessionStorage.getItem('defaultLocation'))[0].accountNumber;
    }
    return b2bUid;
  }

  fetchUserAndCardDetails() {

    this.userDataSub = this.user.get().subscribe((res: any) => {
      if (res) {
        this.userId = res?.uid;
        this.userFname = res?.firstName;
        this.userLname = res?.lastName;
        this.userEmail = res?.email;

        this.settingStdCartAccountDetals();
      }
    });

    this.addCardSubscriber = this.addCardService.cardAdded.subscribe((res) => {
      //refreshing list of cards and accounts in case
      if (res) {
        this.newCardOrAccountDetails = res;
        //checking if newly added card already present in list
        const existingCheck1 = this.newCardOrAccountDetailsArr?.find(cardOrAcc => cardOrAcc?.cardNumber == this.newCardOrAccountDetails?.cardNumber);
        const existingCheck2 = this.userCardDataArray?.find(cardOrAcc => cardOrAcc?.cardNumber == this.newCardOrAccountDetails?.cardNumber);
        const existingCheck3 = this.userAccountDataArray?.find(cardOrAcc => cardOrAcc?.cardNumber == this.newCardOrAccountDetails?.cardNumber);
        //if newly added card/acc not present in any of existing list
        if (!existingCheck1 && !existingCheck2 && !existingCheck3) {
          this.addNewCardOrAccToList();
        }
        else {
          let cardOrAcc = this.newCardOrAccountDetails?.cardType == 'EC' ? 'account' : 'card';
          let errorMessage = `This ${cardOrAcc} already exists for this customer. Please try with another ${cardOrAcc}.`;
          this.globalMessage.add(errorMessage,
            GlobalMessageType.MSG_TYPE_ERROR, 5000
          );
        }

        // this.getCardDetailsForStdCart(this.usergetDataObj?.uid);
      }
    });
  }

  addNewCardOrAccToList() {
    //newly added card or account
    if (this.newCardOrAccountDetails?.cardType != 'EC') {
      //if any previously added new card, then make it as false for default
      this.userCardDataArray?.map(element => {
        if (element?.newCardDefault) {
          element.newCardDefault = false;
        }
      });
      const card = `${this.newCardOrAccountDetails?.cardType} Card(XXXX-XXXX-XXXX-${this.newCardOrAccountDetails?.cardNumber?.substring(6, 10)})`;
      const objNewCard = {
        name: card,
        code: this.userCardDataArray?.length + 1,
        cardHolderName: this.newCardOrAccountDetails?.creditCardName ? this.newCardOrAccountDetails?.creditCardName : '',
        creditCardName: this.newCardOrAccountDetails?.creditCardName ? this.newCardOrAccountDetails?.creditCardName : '',
        cardNumber: this.newCardOrAccountDetails?.cardNumber ? this.newCardOrAccountDetails?.cardNumber : '',
        cardType: this.newCardOrAccountDetails?.cardType ? this.newCardOrAccountDetails?.cardType : '',
        expDate: this.newCardOrAccountDetails?.expDate ? this.newCardOrAccountDetails?.expDate : '',
        creditCardDefault: this.newCardOrAccountDetails?.creditCardDefault ? this.newCardOrAccountDetails?.creditCardDefault : false,
        cardExpired: this.newCardOrAccountDetails?.cardExpired ? this.newCardOrAccountDetails?.cardExpired : false,
        routingNumber: this.newCardOrAccountDetails?.routingNumber ? this.newCardOrAccountDetails?.routingNumber : '',
        newCardDefault: true
      };
      this.newCardOrAccountDetailsArr.push(objNewCard);
      this.sharedService.setSessionStorage('tempoData', this.newCardOrAccountDetailsArr);
      this.userCardDataArray = [objNewCard, ...this.userCardDataArray]
      this.ref.detectChanges();

      //1st checking if newly added card, then make that default
      this.chosenCard = this.userCardDataArray.find(
        (item) => item?.newCardDefault === true
      )?.code;
      if (!this.chosenCard) { //if no new card/acc added, then check for by default creditCardDefault
        this.chosenCard = this.userCardDataArray.find(
          (item) => item?.creditCardDefault === true
        )?.code;
      }
      this.ref.detectChanges();
      if (this.chosenCard != null && this.chosenCard != undefined && this.chosenCard != 0) {
        // let paymentPreferenceCode = '';
        // if (this.paymentPreference === 'PI') {
        //   paymentPreferenceCode = 'PAY_BY_CARD'
        // }
        // if (this.paymentPreference === 'FP') {
        //   paymentPreferenceCode = 'PAY_BY_CREDIT_CARD_3DPRIOR'
        // }
        // if (paymentPreferenceCode !== '') {
        //   this.chosenPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.code;
        //   this.displayPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.name;
        //   this.selectedPaymentMethodEvent.emit({ code: this.chosenPaymentMethod, name: this.displayPaymentMethod });
        // }
        let sltdCardDetails = this.userCardDataArray.filter(
          (item) => item.code === this.chosenCard
        );
        sltdCardDetails = Object.assign({}, ...sltdCardDetails);
        this.selectedcardHolderName = sltdCardDetails?.cardHolderName; //creditCardName only in actual response
        this.selectedcardNumber = sltdCardDetails?.cardNumber;
        this.selectedcardType = sltdCardDetails?.cardType;
        this.selectedcardRoutingNumber = sltdCardDetails?.routingNumber;
        this.selectedexpDate = sltdCardDetails?.expDate;
        this.selectedExpWithinSixMonths = this.isExpDateWithinSixMonths(this.selectedexpDate);
        this.cardExpiredFlag = sltdCardDetails?.cardExpired;
        this.creditCardDefault = sltdCardDetails?.newCardDefault ? sltdCardDetails?.newCardDefault : sltdCardDetails?.creditCardDefault;

        // if (this.paymentPreference == 'BM') {
        //   this.emitCardOrAccountDetails();
        // }
        // else {
        //   this.emitCardOrAccountDetails('CARD');
        // }
        this.selectedExpWithinSixMonths = this.isExpDateWithinSixMonths(this.selectedexpDate);

        if (this.selectedExpWithinSixMonths) {
          // this.expiryPopoverDisplay(this.expiryPopover);
          this.closePopover(this.expiryPopoverDefault); //if opened for default card, closing it
          this.openPopover(this.expiryPopover);
        }
        else{ //if opened for previous card, close it.
          this.closePopover(this.expiryPopover);
          this.closePopover(this.expiryPopoverDefault); //if opened for default card, closing it
        }
        this.emitCardOrAccountDetails('CARD');
      }
    }
    else if (this.newCardOrAccountDetails?.cardType == 'EC') {//Checking account for EC
      //if any previously added new card, then make it as false for default
      this.userAccountDataArray?.map(element => {
        if (element?.newAccDefault) {
          element.newAccDefault = false;
        }
      });
      const acc = `Account ending in ${this.newCardOrAccountDetails?.cardNumber.substring(6, 10)}`;
      const objNewAcc = {
        name: acc,
        code: this.userAccountDataArray?.length + 1,
        accHolderName: this.newCardOrAccountDetails?.creditCardName ? this.newCardOrAccountDetails?.creditCardName : '',
        creditCardName: this.newCardOrAccountDetails?.creditCardName ? this.newCardOrAccountDetails?.creditCardName : '',
        bankName: this.newCardOrAccountDetails?.issuer ? this.newCardOrAccountDetails?.issuer : '',
        accDefault: this.newCardOrAccountDetails?.creditCardDefault ? this.newCardOrAccountDetails?.creditCardDefault : false,
        cardNumber: this.newCardOrAccountDetails?.cardNumber ? this.newCardOrAccountDetails?.cardNumber : '',
        cardType: this.newCardOrAccountDetails?.cardType ? this.newCardOrAccountDetails?.cardType : '',
        expDate: this.newCardOrAccountDetails?.expDate ? this.newCardOrAccountDetails?.expDate : '',
        cardExpired: this.newCardOrAccountDetails?.cardExpired ? this.newCardOrAccountDetails?.cardExpired : false,
        routingNumber: this.newCardOrAccountDetails?.routingNumber ? this.newCardOrAccountDetails?.routingNumber : '',
        newAccDefault: true
      };
      this.newCardOrAccountDetailsArr.push(objNewAcc);
      this.sharedService.setSessionStorage('tempoData', this.newCardOrAccountDetailsArr);
      // this.userAccountDataArray.push(objNewAcc);
      this.userAccountDataArray = [objNewAcc, ...this.userAccountDataArray]
      this.ref.detectChanges();

      //1st checking if newly added acc, then make that default
      this.chosenAccount = this.userAccountDataArray.find((item) => item?.newAccDefault === true)?.code;
      if (!this.chosenAccount) { //if no new card/acc added, then check for by default creditCardDefault
        this.chosenAccount = this.userAccountDataArray.find((item) => item?.accDefault === true)?.code;
      }
      this.ref.detectChanges();
      if (this.chosenAccount != null && this.chosenAccount != undefined) {
        // let paymentPreferenceCode = '';
        // if (this.paymentPreference === 'PI') {
        //   paymentPreferenceCode = 'PAY_BY_CHK_ACCOUNT'
        // }
        // if (this.paymentPreference === 'FP') {
        //   paymentPreferenceCode = 'PAY_BY_CHK_ACCOUNT_3DPRIOR'
        // }
        // if (paymentPreferenceCode !== '') {
        //   this.chosenPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.code;
        //   this.displayPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.name;
        //   this.selectedPaymentMethodEvent.emit({ code: this.chosenPaymentMethod, name: this.displayPaymentMethod });
        // }
        let sltdAccDetails = this.userAccountDataArray.filter(
          (item) => item.code === this.chosenAccount
        );
        sltdAccDetails = Object.assign({}, ...sltdAccDetails);
        this.selectedAccountHolderName = sltdAccDetails?.accHolderName; //creditCardName only in actual response
        this.selectedAccountNumber = sltdAccDetails?.cardNumber;
        this.selectedAccountRoutingNumber = sltdAccDetails?.routingNumber;
        this.selectedAccountType = sltdAccDetails?.cardType;
        this.selectedAccountexpDate = sltdAccDetails?.expDate;
        this.accExpiredFlag = sltdAccDetails?.cardExpired;
        this.accDefault = sltdAccDetails?.newAccDefault ? sltdAccDetails?.newAccDefault : sltdAccDetails?.accDefault;

        // if (this.paymentPreference == 'BM') {
        //   this.emitCardOrAccountDetails();
        // }
        // else {
        //   this.emitCardOrAccountDetails('ACC');
        // }
        this.emitCardOrAccountDetails('ACC');
      }
    }

    this.ref.detectChanges();

  }

  getPaymentMethods(): Observable<any> {
    return this.paymentMethodService.getAllPaymentMethods({
      enumerationType: 'paymentMethod',
      fields: 'DEFAULT',
    });
  }

  setPaymentDetails(paymentData) {
    this.chosenPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentData?.paymentMethod)?.code;
    this.displayPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentData?.paymentMethod)?.name;
    this.selectedPaymentMethodEvent.emit({ code: this.chosenPaymentMethod, name: this.displayPaymentMethod });


    if (paymentData?.paymentType == 'ACCOUNT') {
      this.selectedAccountType = paymentData?.cardType;
      this.selectedAccountNumber = paymentData?.cardNumber;
      this.selectedAccountHolderName = paymentData?.cardHolderName;
      this.selectedAccountRoutingNumber = paymentData?.routingNumber;

      const acc = `Account ending in ${paymentData?.cardNumber.substring(6, 10)}`;
      const objAcc = {
        name: acc,
        code: 1,
        accHolderName: this.selectedAccountHolderName,
        bankName: '', //not emitted nor recieved
        accDefault: false, ////not emitted nor recieved
        cardNumber: this.selectedAccountNumber,
        cardType: this.selectedAccountType,     //EC
        expDate: paymentData?.expDate,       //''
        cardExpired: false,                 //not emitted nor recieved
        routingNumber: this.selectedAccountRoutingNumber
      };
      this.userAccountDataArray.push(objAcc);
      this.chosenAccount = 1; //only 1 account will be there only in array
      this.emitCardOrAccountDetails('ACC');
    }
    else if (paymentData?.paymentType == 'CARD') {
      this.selectedcardType = paymentData?.cardType;
      this.selectedcardNumber = paymentData?.cardNumber;
      this.selectedexpDate = paymentData?.expDate;
      this.selectedcardHolderName = paymentData?.cardHolderName;

      const card = `${paymentData?.cardType} Card(XXXX-XXXX-XXXX-${paymentData?.cardNumber.substring(6, 10)})`;
      const objCard = {
        name: card,
        code: 1,
        cardHolderName: this.selectedcardHolderName,
        cardNumber: this.selectedcardNumber,
        cardType: this.selectedcardType,
        expDate: this.selectedexpDate,
        creditCardDefault: false,//not emitted nor recieved
        cardExpired: false,//not emitted nor recieved
        routingNumber: paymentData?.routingNumber // ''
      };
      this.userCardDataArray.push(objCard);
      this.chosenCard = 1; //only 1 card will be there only in array
      // this.emitCardOrAccountDetails('CARD');
      if(!this.orderFlu && (this.editFluReservation || this.cancelFluReservation)){
        this.selectedExpWithinSixMonths = this.isExpDateWithinSixMonths(this.selectedexpDate);
        if (this.selectedExpWithinSixMonths) {
          //console.log('order card exp date',this.selectedexpDate);
          //In case of edit, if order has card exp date less than 6, call the api to get card details from profile and get updated exp date
          this.getCardDetailsAndUpdateExpDate(paymentData)
          // this.closePopover(this.expiryPopoverDefault); //if opened for default card, closing it
          // this.openPopover(this.expiryPopover);
        }
        else{ //if opened for previous card, close it.
          this.closePopover(this.expiryPopover);
          this.closePopover(this.expiryPopoverDefault); //if opened for default card, closing it
          this.emitCardOrAccountDetails('CARD');
       }
      }
      else{
        this.emitCardOrAccountDetails('CARD');
      }
    }
    else {
      //nothing to be done
      this.emitCardOrAccountDetails();
    }

  }


  settingStdCartAccountDetals(){
    //check the route to see if it's checkout screen
    this.stdCheckoutFlow && this.sharedService.getSessionStorage('selectedLocations') ?
    this.getCardDetailsForStdCart(this.sharedService.getSessionStorage('selectedLocations')[0].accountNumber)  :
    this.pfService.userAccountDetails.pipe(filter(res => !!res),map(({res}) => res.uid),take(1)).subscribe(res => this.getCardDetailsForStdCart(res));
    this.ref.detectChanges();
  }

  setDefaultPaymentPreference() {
    if (this.paymentPreference !== undefined && this.paymentPreference !== null) {
      const paymentPreferenceCode = paymentPreferenceMapping[this.paymentPreference];
      if (paymentPreferenceCode !== undefined && paymentPreferenceCode !== null && paymentPreferenceCode != 'NO_PRE_SELECT') {
        this.chosenPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.code;
        this.displayPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.name;
        this.selectedPaymentMethodEvent.emit({ code: this.chosenPaymentMethod, name: this.displayPaymentMethod });
      }
    }
    else { //If no payment prefernce, then setting "bill me later" as default
      this.chosenPaymentMethod = this.paymentMethodsArray.find((item) => item.code === enumPaymentMethods.BILL_ME_LATER)?.code;
      this.displayPaymentMethod = this.paymentMethodsArray.find((item) => item.code === enumPaymentMethods.BILL_ME_LATER)?.name;
      this.selectedPaymentMethodEvent.emit({ code: this.chosenPaymentMethod, name: this.displayPaymentMethod });
    }
  }

  getCardDetailsForStdCart(accountId) {
    this.selectedcardHolderName = '';
    this.selectedcardNumber = '';
    this.selectedcardType = '';
    this.selectedexpDate = '';
    this.selectedPaymentMethod = enumPaymentMethods.BILL_ME_LATER;

    this.pfService.getCardFromDb(this.userId, accountId);

    this.cardDetailsPfSubscriber = this.pfService.cardDetails.subscribe((data) => {
      if (data) {
        this.userCardDataArray = [];
        this.userAccountDataArray = [];
        if (this.userTemporaryCard) {
          this.userCardDataArray.push(this.userTemporaryCard);
        }
        this.userCardData = data?.sanofiPaymentsResponseList; // user saved cards and checking account details
        //adding newly added cards/acc during checkout(if available) to fetched list
        if (this.newCardOrAccountDetailsArr?.length > 0) {
          let tempCardAccArr = [];
          this.newCardOrAccountDetailsArr?.map(newCardOrAcc => {
            const existingCheck = this.userCardData?.find(cardOrAcc => cardOrAcc?.cardNumber == newCardOrAcc?.cardNumber);
            if (!existingCheck) {
              tempCardAccArr.push(newCardOrAcc)
            }
          })
          // this.userCardData = [...this.newCardOrAccountDetailsArr, ...this.userCardData];
          this.userCardData = [...tempCardAccArr, ...this.userCardData];
        }
        if (this.userCardData?.length > 0) {
          this.userCardData.forEach((element, index) => {
            if (element?.cardType != 'EC') {
              const card = `${element?.cardType} Card(XXXX-XXXX-XXXX-${element?.cardNumber.substring(6, 10)})`;
              const objCard = {
                name: card,
                //code: index + 1,
                code: this.userCardDataArray?.length + 1,
                cardHolderName: element?.creditCardName,
                cardNumber: element?.cardNumber,
                cardType: element?.cardType,
                expDate: element?.expDate,
                creditCardDefault: element?.creditCardDefault,
                cardExpired: element?.cardExpired,
                routingNumber: element?.routingNumber ? element?.routingNumber : '',
                newCardDefault: element?.newCardDefault ? element?.newCardDefault : false
              };
              this.userCardDataArray.push(objCard);
              //this.chosenAccount = this.userAccountDataArray.find((item) => item.accDefault === true)?.code;
            }
            else { //Checking account for EC
              const acc = `Account ending in ${element?.cardNumber.substring(6, 10)}`;
              const objAcc = {
                name: acc,
                // code: index + 1,
                code: this.userAccountDataArray?.length + 1,
                accHolderName: element?.creditCardName,
                bankName: element?.issuer,
                accDefault: element?.creditCardDefault,
                cardNumber: element?.cardNumber,
                cardType: element?.cardType,
                expDate: element?.expDate,
                cardExpired: element?.cardExpired,
                routingNumber: element?.routingNumber,
                newAccDefault: element?.newAccDefault ? element?.newAccDefault : false
              };
              this.userAccountDataArray.push(objAcc);
            }
          });
          this.ref.detectChanges();
        }
        if (!this.userTemporaryCard) {
          //1st checking if newly added card, then make that default
          this.chosenCard = this.userCardDataArray.find(
            (item) => item?.newCardDefault === true
          )?.code;
          if (!this.chosenCard) { //if no new card/acc added, then check for by default creditCardDefault
            this.chosenCard = this.userCardDataArray.find(
              (item) => item?.creditCardDefault === true
            )?.code;
          }
        } else {
          this.chosenCard = 0;
        }
        if (this.chosenCard != null && this.chosenCard != undefined && this.chosenCard != 0) {
          let paymentPreferenceCode = '';
          if (this.paymentPreference === 'PI') {
            paymentPreferenceCode = 'PAY_BY_CARD'
          }
          if (this.paymentPreference === 'FP') {
            paymentPreferenceCode = 'PAY_BY_CREDIT_CARD_3DPRIOR'
          }
          if (paymentPreferenceCode !== '') {
            this.chosenPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.code;
            this.displayPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.name;
            this.selectedPaymentMethodEvent.emit({ code: this.chosenPaymentMethod, name: this.displayPaymentMethod });
          }
          let sltdCardDetails = this.userCardDataArray.filter(
            (item) => item.code === this.chosenCard
          );
          sltdCardDetails = Object.assign({}, ...sltdCardDetails);
          this.selectedcardHolderName = sltdCardDetails?.cardHolderName; //creditCardName only in actual response
          this.selectedcardNumber = sltdCardDetails?.cardNumber;
          this.selectedcardType = sltdCardDetails?.cardType;
          this.selectedcardRoutingNumber = sltdCardDetails?.routingNumber;
          this.selectedexpDate = sltdCardDetails?.expDate;
          this.selectedExpWithinSixMonths = this.isExpDateWithinSixMonths(this.selectedexpDate);

          if (this.selectedExpWithinSixMonths) {
            // this.expiryPopoverDisplay(this.expiryPopover);
            this.openPopover(this.expiryPopover);
          }
          else{
            this.closePopover(this.expiryPopover);
          }
          this.cardExpiredFlag = sltdCardDetails?.cardExpired;
          this.creditCardDefault = sltdCardDetails?.newCardDefault ? sltdCardDetails?.newCardDefault : sltdCardDetails?.creditCardDefault;

          if (this.paymentPreference == 'BM') {
            this.emitCardOrAccountDetails();
          }
          else {
            this.emitCardOrAccountDetails('CARD');
          }
        }

        //1st checking if newly added acc, then make that default
        this.chosenAccount = this.userAccountDataArray.find((item) => item?.newAccDefault === true)?.code;
        if (!this.chosenAccount) { //if no new card/acc added, then check for by default creditCardDefault
          this.chosenAccount = this.userAccountDataArray.find((item) => item?.accDefault === true)?.code;
        }
        if (this.chosenAccount != null && this.chosenAccount != undefined) {
          let paymentPreferenceCode = '';
          if (this.paymentPreference === 'PI') {
            paymentPreferenceCode = 'PAY_BY_CHK_ACCOUNT'
          }
          if (this.paymentPreference === 'FP') {
            paymentPreferenceCode = 'PAY_BY_CHK_ACCOUNT_3DPRIOR'
          }
          if (paymentPreferenceCode !== '') {
            this.chosenPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.code;
            this.displayPaymentMethod = this.paymentMethodsArray.find((item) => item.code === paymentPreferenceCode)?.name;
            this.selectedPaymentMethodEvent.emit({ code: this.chosenPaymentMethod, name: this.displayPaymentMethod });
          }
          let sltdAccDetails = this.userAccountDataArray.filter(
            (item) => item.code === this.chosenAccount
          );
          sltdAccDetails = Object.assign({}, ...sltdAccDetails);
          this.selectedAccountHolderName = sltdAccDetails?.accHolderName; //creditCardName only in actual response
          this.selectedAccountNumber = sltdAccDetails?.cardNumber;
          this.selectedAccountRoutingNumber = sltdAccDetails?.routingNumber;
          this.selectedAccountType = sltdAccDetails?.cardType;
          this.selectedAccountexpDate = sltdAccDetails?.expDate;
          this.accExpiredFlag = sltdAccDetails?.cardExpired;
          this.accDefault = sltdAccDetails?.newAccDefault ? sltdAccDetails?.newAccDefault : sltdAccDetails?.accDefault;

          if (this.paymentPreference == 'BM') {
            this.emitCardOrAccountDetails();
          }
          else {
            this.emitCardOrAccountDetails('ACC');
          }
        }
        this.ref.detectChanges();
        this.cardDetailsPfSubscriber?.unsubscribe();
      }
    });
  }


  getPaymentDetailsOfUser(event) {
    this.selectedPaymentMethod = event.code;
    this.selectedPaymentMethodEvent.emit(event);
    this.displayPaymentMethod = this.paymentMethodsArray.find((item) => item.code === event.code)?.name;

    if (event.code === enumPaymentMethods.BILL_ME_LATER) { //bill me later
      // this.selectedcardHolderName = '';
      // this.selectedcardNumber = '';
      // this.selectedcardType = '';
      // this.selectedexpDate = '';
      this.emitCardOrAccountDetails();
      //closing expiry popover if opened on changing payment method to acc or BM
      this.closePopover(this.expiryPopover);
      this.closePopover(this.expiryPopoverDefault);
    }
    else if (event.code === enumPaymentMethods.PAY_BY_CARD || event.code === enumPaymentMethods.PAY_BY_CREDIT_CARD_3DPRIOR) { //2.Pay by card

      this.emitCardOrAccountDetails('CARD');

      if (this.cardExpiredFlag) {
        this.translation.translate('addToCartItems.cardExpMsg').subscribe((res) => {
          this.globalMessage.add(res,
            GlobalMessageType.MSG_TYPE_ERROR
          );
        });
      }
      else {
        if (this.selectedExpWithinSixMonths) {

          // this.expiryPopoverDisplay(this.expiryPopoverDefault);
          this.closePopover(this.expiryPopover);
          this.openPopover(this.expiryPopoverDefault);
        }
        else{//if opened for previous card, close it.
          this.closePopover(this.expiryPopoverDefault);
        }
      }
    }
    else if (event.code === enumPaymentMethods.PAY_BY_CHK_ACCOUNT || event.code === enumPaymentMethods.PAY_BY_CHK_ACCOUNT_3DPRIOR) { //Pay by checking account
      this.emitCardOrAccountDetails('ACC');
      //closing expiry popover if opened on changing payment method to acc or BM
      this.closePopover(this.expiryPopover);
      this.closePopover(this.expiryPopoverDefault);
    }
  }

  emitCardOrAccountDetails(type?: string) {
    let obj;
    if (type == 'CARD') {
      obj = {
        'cardType': this.selectedcardType,
        'cardNumber': this.selectedcardNumber,
        'expDate': this.selectedexpDate,
        'cardHolderName': this.selectedcardHolderName,
        'paymentType': 'CARD',
        'routingNumber': ''  //shd be blank for CC cards
      };
    }
    else if (type == 'ACC') {
      obj = {
        'cardType': this.selectedAccountType,
        'cardNumber': this.selectedAccountNumber,
        'expDate': '', //shd be blank for ACC - EC type
        'cardHolderName': this.selectedAccountHolderName,
        'paymentType': 'ACCOUNT',
        'routingNumber': this.selectedAccountRoutingNumber
      };
    }
    else {
      obj = { 'cardType': '', 'cardNumber': '', 'expDate': '', 'cardHolderName': '', 'paymentType': '', 'routingNumber': '' };
    }
    this.selectedCardOAcctDetailsEvent.emit(obj);
    this.ref.detectChanges();
  }

  getCardDetailsOfUser(event) {
    this.selectedcardHolderName = event?.cardHolderName;
    this.selectedcardNumber = event?.cardNumber;
    this.selectedcardType = event?.cardType;
    this.selectedexpDate = event?.expDate;
    this.selectedcardRoutingNumber = event?.routingNumber;
    this.cardExpiredFlag = event?.cardExpired;

    this.emitCardOrAccountDetails('CARD')

    if (this.cardExpiredFlag) {
      this.translation.translate('addToCartItems.cardExpMsg').subscribe((res) => {
        this.globalMessage.add(res,
          GlobalMessageType.MSG_TYPE_ERROR
        );
      });
    }
    else { //checking expiry within 6 months if not expired already
      this.selectedExpWithinSixMonths = this.isExpDateWithinSixMonths(this.selectedexpDate);
      if (this.selectedExpWithinSixMonths) {
        // this.expiryPopoverDisplay(this.expiryPopover);
        this.closePopover(this.expiryPopoverDefault); //if opened for default card, closing it
        this.openPopover(this.expiryPopover);
      }
      else{//if opened for previous card, close it.
        this.closePopover(this.expiryPopover);
        this.closePopover(this.expiryPopoverDefault); //if opened for default card, closing it
      }
    }
  }

  getAccountDetailsOfUser(event) {
    this.selectedAccountHolderName = event?.accHolderName;
    this.selectedAccountNumber = event?.cardNumber;
    this.selectedAccountType = event?.cardType;
    this.selectedAccountBankName = event?.bankName;
    this.selectedAccountexpDate = event?.expDate;
    this.selectedAccountRoutingNumber = event?.routingNumber;

    this.emitCardOrAccountDetails('ACC');
  }

  isExpDateWithinSixMonths(expDate: string) {
    let currDate = this.datepipe.transform(new Date(), 'MM/yyyy');
    let dateSplit = expDate.split('/')
    var expFullDate = new Date(Number(dateSplit[1]), Number(dateSplit[0]), 0);
    let sixMonthsFromNow = new Date();
    sixMonthsFromNow = new Date(sixMonthsFromNow.getFullYear(), sixMonthsFromNow.getMonth() + 6, 0);
    return expDate != currDate && expFullDate <= sixMonthsFromNow;
  }


  expiryPopoverDisplay(popover) {
    // clearTimeout(this.popoverCloseTimeOut);
    // const num = 3000;
    if (popover) {
      popover?.toggle();
      // this.popoverCloseTimeOut = setTimeout(() => popover?.close(), num);
    }
  }

  closePopover(popover) {
    if (popover !== undefined) {
      this.currentPopover = popover;
      if (this.currentPopover.isOpen()) {
        this.currentPopover.close();
      }
    }
  }
  openPopover(popover) {
    if (popover !== undefined) {
      this.currentPopover = popover;
      if (!this.currentPopover.isOpen()) {
        this.currentPopover.open();
      }
    }
  }

  redirectToPaymentSettings(event) {
    this.router.goByUrl('/my-account/profile');
    this.checkoutService.tabSelection('Payment settings');
  }
  openCardModal() {
    const modref = this.modalService.open(AddCardComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `addCardModal ${this.baseSiteId}`
    });
    modref.componentInstance.isCheckbox = false;
    modref.componentInstance.isCheckout = true;
    this._datalayer.addtoDataLayer('addCard_FormEvent', 'card', '', '', 'form_start', '');
  }
  openAccountModal(event) {
    const modref = this.modalService.open(AddCardComponent, {
      centered: true,
      backdrop: 'static',
      windowClass: `addCardModal ${this.baseSiteId}`
    });
    modref.componentInstance.isCheckbox = false;
    modref.componentInstance.forCheckingAccounts = true;
    modref.componentInstance.isCheckout = true;
    this._datalayer.addtoDataLayer('addCard_FormEvent', 'account', '', '', 'form_start', '');
  }

  checkMFAMethods() {
    // alert('MFA here checkout')
    this.mfaService.multiFactorAuth('add_new_credit_card');
    this.mfaSubscription = this.mfaService.multiFactorAuthResult.subscribe(res => res?.status ? this.openCardModal() : '');
  }

  ngOnDestroy(): void {
    this.userDataSub?.unsubscribe();
    this.userAccountSubscriber?.unsubscribe();
    this.userAccountDetailsSubscriber?.unsubscribe();
    this.cardDetailsPfSubscriber?.unsubscribe();
    this.addCardSubscriber?.unsubscribe();
    this.csAgentAuthSubscription?.unsubscribe();
    this.editCancelFluSub?.unsubscribe();
    this.mfaSubscription?.unsubscribe();
  }
}